<ui-headline-wrapper>
    <ui-headline [title]="isEditFormMode ? (partner$ | async)?.orgName : ('modules.partners.blank' | translate)"
                 [backLinkPaths]="[routeEntity.Root, routeEntity.Partners]" />
</ui-headline-wrapper>

<ui-content-wrapper>
    @if (!isEditFormMode || (isEditFormMode && partner$ | async)) {
        <users-partner-form
            [lyView]="readonlyMode$ | async"
            [organizations]="organizations$ | async"
            [isEditMode]="isEditFormMode"
            [handlers]="handlersForm"
            [partner]="partner$ | async"
            [pending]="pending$ | async" />
    } @else {
        <ui-pre-loader />
    }
</ui-content-wrapper>
